export class PositionParamsDtos {
    Name: string;
    SubordinatePositionId: number;
    EmployeeName: string;
    EmployeeEmail: string;
    AllStores: boolean;
    CatDetJobId: number;
    CatDetCountryId: number;
    OrganizationId: string;
}
